import React, { useContext, useEffect, useState } from "react";
import ReactExport from "react-data-export";
import { Button } from "@material-ui/core";
import { ReportFranchiseeContext } from "../../context/ReportFranchiseeContext";
import "../../styles/global.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const ExportExcel = () => {
  const { valuesTable } = useContext(ReportFranchiseeContext);
  const [dataExcel, setDataExcel] = useState([]);
  const [styleButton, setStyleButton] = useState({});

  useEffect(() => {
    setStyleButton({ display: "none" });

    const allColumns = [
      { name: "Franquia CNPJ", key: "FranquiaCNPJ", alignment: "left" },
      { name: "Cliente CNPJ", key: "ClienteCNPJ", alignment: "left" },
      { name: "Razão", key: "Razao", alignment: "left", width: 40 },
      { name: "Família", key: "Familia", alignment: "center" },
      { name: "Produto", key: "Produto", alignment: "center" },
      { name: "Versão", key: "Versao", alignment: "center" },
      { name: "Nome de acesso", key: "Rota", alignment: "left" },
      { name: "Status", key: "MotivoCancelamento", alignment: "center" },
      {
        name: "Parâmetros",
        key: "ValoresParametros",
        alignment: "left",
        width: 100,
      },
    ];

    const data = valuesTable.map(item => {
      return allColumns.map(object =>
        item[object.key]
          ? {
              value: item[object.key],
              style: {
                alignment: {
                  vertical: "center",
                  horizontal: object.alignment,
                },
              },
            }
          : { value: "" }
      );
    });

    const styleColumns = {
      font: { color: { rgb: "ffffff" }, bold: true },
      fill: { fgColor: { rgb: "212121" } },
      alignment: { vertical: "center", horizontal: "center" },
    };

    const columns = allColumns.map(object => {
      return {
        title: object.name,
        width: { wch: object.width || 15 },
        style: styleColumns,
      };
    });

    setDataExcel([{ columns, data }]);
    setStyleButton({});
  }, [valuesTable]);

  return (
    <ExcelFile
      filename={`consumoERP`}
      element={
        <Button className="excel-export-button" style={styleButton}>
          <img src="./img/excel.png" alt="Excel" />
          Exportar
        </Button>
      }
    >
      <ExcelSheet dataSet={dataExcel} name="ConsumoERP"></ExcelSheet>
    </ExcelFile>
  );
};

export default ExportExcel;
